/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Budget_DemoInputs */

const en_gc_home_budget_demo = /** @type {(inputs: Gc_Home_Budget_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interactive budget demonstration`)
};

const zh_gc_home_budget_demo = /** @type {(inputs: Gc_Home_Budget_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可编辑预算演示`)
};

/**
* | output |
* | --- |
* | "Interactive budget demonstration" |
*
* @param {Gc_Home_Budget_DemoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_budget_demo = /** @type {((inputs?: Gc_Home_Budget_DemoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Budget_DemoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_budget_demo(inputs)
	return zh_gc_home_budget_demo(inputs)
});
export { gc_home_budget_demo as "gc.home.budget_demo" }